import React from 'react';
import './loader.scss';

const AppLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader" />
    </div>
  );
};

export default AppLoader;
